import { Injectable } from '@angular/core';
import { CVApiService } from '../../../reusables/services/cv-api.service';
import { SuggestCoachingModalData, SuggestedSessionData } from './suggest-coaching-modal.models';

@Injectable({
    providedIn: 'root'
})
export class SuggestCoachingModalService {
    private static readonly API_PATH = "/api/v2/coaching/suggestcoaching";
    constructor(
        private cvApiService: CVApiService
    ) { }

    public async getSupportData(groupID) {
        let apiroute = `${SuggestCoachingModalService.API_PATH}/supportdata`;
        try {
            if (groupID)
                apiroute += `?groupID=${groupID}`;
            const response = await this.cvApiService.get<SuggestCoachingModalData>(apiroute);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting suggested coaching support data`);
            throw err;
        }
    };

    public async createNewSuggestedSession(sessionData: SuggestedSessionData) {
        let apiroute = `${SuggestCoachingModalService.API_PATH}`;
        try {
            const response = await this.cvApiService.post(apiroute, sessionData);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed creating new suggested session`);
            throw err;
        }

    }
}
